import { StyleSheet, View } from 'react-native'
import FocusAwareStatusBar from '../../Components/FocusAwareStatusBar'
import { WebView } from 'react-native-webview'
import { BASE_URL } from '../../config'
import Header from '../../Components/Header'
import { useNavigation } from '@react-navigation/native'
import { useLayoutEffect } from 'react'
import { useLocalisationContext } from '../../Providers/LocalisationProvider'


const CookiePolicyScreen = () => {

    const source = `${BASE_URL}/legal/cookie-policy`
    const navigation = useNavigation()
    const lang = useLocalisationContext()

    useLayoutEffect(() => {
        navigation.setOptions({
            headerShown: false,
        })
    }, [])

    return (
        <View style={styles.container}>
            <FocusAwareStatusBar barStyle="dark-content" />
            <Header title={lang.t('cookies_policy')} />
            <WebView 
            style={styles.container}
            source={{ uri: source }}
            />
        </View>
    )
}

export default CookiePolicyScreen

const styles = StyleSheet.create({
    container: {
        flex: 1,
    }
})